<p-table [value]="suspended" [selection]="selectedVoters" (selectionChange)="selectionChangedEvent($event)"
  [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 50, 100]"
  [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}" styleClass="p-datatable-striped">
  <ng-template pTemplate="header">
    <tr class="bg-light-gray">
      <th pSortableColumn="lastName" class="grey"
        style="width: 15%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Nom <p-sortIcon field="lastName"></p-sortIcon>
      </th>
      <th pSortableColumn="firstName" class="grey"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Prénom
        <p-sortIcon field="firstName"></p-sortIcon>
      </th>
      <th pSortableColumn="email" class="grey"
        style="width: 30%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Email
        <p-sortIcon field="email"></p-sortIcon>
      </th>
      <th pSortableColumn="attempts" class="grey"
        style="width: 10%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Tentatives
        <p-sortIcon field="attempts"></p-sortIcon>
      </th>
      <th pSortableColumn="lockDate" class="grey"
        style="width: 20%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Date de blocage
        <p-sortIcon field="lockDate"></p-sortIcon>
      </th>
      <th pSortableColumn="lockDate" class="grey"
        style="width: 15%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Durée restante
        <p-sortIcon field="lockDate"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-voter let-rowIndex="rowIndex">
    <tr [ngClass]="{'bg-light-gray': rowIndex % 2 === 0}">
      <td class="text-center pt-5 pb-5">
        <p class="dark-blue no-margin bold">{{ voter.lastName }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ voter.firstName }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ voter.email }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ voter.attempts }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ voter.lockDate | date:'dd/MM/yyyy HH:mm' }}</p>
      </td>
      <td class="text-center">
        <p class="dark-blue no-margin bold">{{ getRemainingTime(voter) }}</p>
      </td>
    </tr>
  </ng-template>
</p-table>